import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-custom-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CustomRedirectComponent {}
